import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiError } from '../../api/client'
import { Button, Field, Input } from '@bb/ui'
import { de } from '../../i18n'
import { AuthLayout } from './AuthLayout'
import { useLogin, useLogout } from './useSession'

export function LoginPage() {
  const navigate = useNavigate()
  const login = useLogin()
  const logout = useLogout()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [deniedAsNonAdmin, setDeniedAsNonAdmin] = useState(false)

  const message = deniedAsNonAdmin
    ? de.auth.login.failed
    : login.error instanceof ApiError
      ? login.error.status === 429
        ? de.auth.login.rateLimited
        : login.error.status === 401
          ? de.auth.login.failed
          : login.error.message
      : null

  return (
    <AuthLayout>
      <form
        noValidate
        className="space-y-4"
        onSubmit={(event) => {
          event.preventDefault()
          setDeniedAsNonAdmin(false)
          login.mutate(
            { email, password },
            {
              onSuccess: ({ user }) => {
                if (user.isAdmin) {
                  navigate('/', { replace: true })
                  return
                }
                // Design §3: a caller without administratorrecht is
                // refused with the exact same message as a wrong
                // password — the credentials were genuine, so the API
                // happily issued a session, but nothing here may show
                // that. Dropping that session immediately (rather than
                // leaving it to expire) means there is nothing left for
                // a browser inspector to notice that this login "worked".
                logout.mutate()
                setDeniedAsNonAdmin(true)
              },
            },
          )
        }}
      >
        <Field label={de.auth.login.email}>
          {({ id }) => (
            <Input
              id={id} type="email" autoComplete="email" required autoFocus
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          )}
        </Field>

        <Field label={de.auth.login.password}>
          {({ id }) => (
            <Input
              id={id} type="password" autoComplete="current-password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          )}
        </Field>

        {message ? (
          <p role="alert" className="rounded-[var(--radius-control)] bg-danger-soft px-3 py-2 text-base text-danger">
            {message}
          </p>
        ) : null}

        <Button type="submit" variant="primary" size="lg" className="w-full justify-center" loading={login.isPending}>
          {de.auth.login.submit}
        </Button>
      </form>
    </AuthLayout>
  )
}
